import { render, staticRenderFns } from "./LawNoteToBeOnInvoiceForm.vue?vue&type=template&id=0ef7b756&"
import script from "./LawNoteToBeOnInvoiceForm.vue?vue&type=script&lang=js&"
export * from "./LawNoteToBeOnInvoiceForm.vue?vue&type=script&lang=js&"
import style0 from "./LawNoteToBeOnInvoiceForm.vue?vue&type=style&index=0&id=0ef7b756&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports